import DetailHorizontal from "./DetailHorizontal.page";

export default DetailHorizontal;
